import Image from "next/image";
import React from "react";

const SearchButton = ({ handleSubmit, isLoading }) => {
  return (
    <button
      type="submit"
      onClick={handleSubmit}
      className="flex items-center justify-center lg:w-[54px] w-full h-[54px] rounded bg-themebgColor transition-all ease-in-out duration-200 hover:bg-opacity-70"
    >
      {isLoading ? (
        <Image
          src="/icons/spinner-white.svg"
          alt="spinner"
          width={24}
          height={24}
          className="animate-spin"
        />
      ) : (
        <Image
          src="/icons/formSearch.svg"
          alt="formSearch"
          width={28}
          height={28}
        />
      )}
    </button>
  );
};

export default SearchButton;
